import { render } from "./template_4.vue?vue&type=template&id=21d9998a&scoped=true"
import script from "./template_4.vue?vue&type=script&lang=js"
export * from "./template_4.vue?vue&type=script&lang=js"

import "./template_4.vue?vue&type=style&index=0&id=21d9998a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/logexpo/logexpo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d9998a"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
